import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { CardActivationPage } from "@/features/cards/pages/card-activation-page";

export const Route = createFileRoute(
	"/_authenticated/card-activation/$cardNumber"
)({
	head: () => pageTitle("Card activation"),
	component: CardActivationPage,
});
